import { Flex } from 'pcln-design-system'
import { type ReactNode } from 'react'
import AdBox from './AdBox'

function AdContent({ children }: { children: ReactNode }) {
  return (
    <Flex alignItems='center' justifyContent='center'>
      {children}
    </Flex>
  )
}

export { AdBox, AdContent }
